//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Table, TableColumn } from 'element-ui'
import { calcPayTotal } from '~/utils/yasaipayHistory'

export default {
  components: {
    ElTable: Table,
    tableColumn: TableColumn,
  },

  props: {
    data: {
      type: Array,
      default: () => [],
    },
    showUserName: {
      type: Boolean,
      default: null,
    },
    showPayDevice: {
      type: Boolean,
      default: null,
    },
  },

  computed: {
    summaryPayTotal() {
      return calcPayTotal(this.data)
    },
  },
}
